import React, { useEffect, useState, useContext } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import ArrowLeft from '@wix/da-ds/pkg/Icons/16x16/ArrowLeft';
import TextInput from '@wix/da-ds/pkg/formControls/dsPresets/TextInput';
import DSModal, { MODAL_FOOTER_BUTTON_SIZE } from '@wix/da-ds/pkg/modals/dsPresets/Modal';
import DSPopover, { POPOVER_FOOTER_BUTTON_SIZE } from '@wix/da-ds/pkg/popovers/dsPresets/Popover';
import FooterButton from '../../../../Popup/_partials/DialogCardLayout/FooterButton';
import { getFolderNameValidationErrorMessage } from '../../../../utils/isValidFolderName';
import s from './NewCollectionPopup.scss';
const NewCollectionPopup = ({ className, folderNameBlacklist, collectibleDeviation, isPrivateCollections, createCollection, isSaving, onClose })=>{
    const { t } = useTranslation();
    const [title, setTitle] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const isMobile = useContext(MobileContext);
    const errorMessage = title ? getFolderNameValidationErrorMessage(title, t, folderNameBlacklist, false) : undefined;
    const onSubmit = ()=>{
        createCollection(title, collectibleDeviation.deviationId, isPrivateCollections);
        setSubmitted(true);
    };
    useEffect(()=>{
        if (submitted && !isSaving) {
            onClose();
        }
    }, [
        submitted,
        isSaving,
        onClose
    ]);
    const content = /*#__PURE__*/ React.createElement("div", {
        className: s['content-wrapper']
    }, /*#__PURE__*/ React.createElement(TextInput, {
        autoFocus: true,
        id: "new-collection-title-input",
        label: t('newCollectionPopup.input.label'),
        value: title,
        validationResult: errorMessage ? 'error' : undefined,
        details: errorMessage,
        onChange: (ev)=>setTitle(ev.target.value),
        onKeyUp: (ev)=>{
            if (ev.key === 'Enter') {
                onSubmit();
            }
        },
        readOnly: isSaving
    }));
    const heading = t(isPrivateCollections ? 'newCollectionPopup.private.title' : 'newCollectionPopup.title');
    const subheading = isPrivateCollections ? t('addToCollectionPopover.private.subtitle') : undefined;
    if (isMobile) {
        return /*#__PURE__*/ React.createElement(DSModal, {
            isOpen: true,
            heading: heading,
            subheading: subheading,
            className: s['root'],
            showHeaderBorder: true,
            showFooterBorder: true,
            footerRight: [
                /*#__PURE__*/ React.createElement(FooterButton, {
                    key: "submit",
                    onClick: onSubmit,
                    size: MODAL_FOOTER_BUTTON_SIZE,
                    fullWidth: false,
                    disabled: !title || errorMessage !== undefined,
                    loading: isSaving
                }, t('newCollectionPopup.button.primary'))
            ],
            withScrollableContentWrapper: false,
            onRequestClose: onClose
        }, content);
    }
    return /*#__PURE__*/ React.createElement(DSPopover, {
        showFooterBorder: true,
        heading: heading,
        subheading: subheading,
        className: c(s['root'], className),
        footerLeft: [
            /*#__PURE__*/ React.createElement(TextButton, {
                key: "back",
                size: "small",
                variant: "main",
                onClick: onClose,
                disabled: isSaving,
                icon: ArrowLeft
            }, t('newCollectionPopup.button.back'))
        ],
        footerRight: [
            /*#__PURE__*/ React.createElement(FooterButton, {
                key: "submit",
                onClick: onSubmit,
                size: POPOVER_FOOTER_BUTTON_SIZE,
                fullWidth: false,
                disabled: !title || errorMessage !== undefined,
                loading: isSaving
            }, t('newCollectionPopup.button.primary'))
        ],
        content: content,
        onCloseClick: onClose
    });
};
NewCollectionPopup.displayName = 'NewCollectionPopup';
export default NewCollectionPopup;

//# sourceMappingURL=NewCollectionPopup.js.map